import React from "react";
import DevicesTable from "./DeviceList";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const DevicePage = () => {
  return (
    <NavHeightAdjust>
      <DevicesTable />
    </NavHeightAdjust>
  );
};

export default DevicePage;
